module.exports = "<div layout-margin> <h1>Listado de compañías</h1> <div layout=row layout-align=\"center center\"> <md-content layout=column layout-padding ng-cloak flex> <md-button ng-click=$ctrl.toggleFiltering()> <md-icon aria-label=\"Mostrar filtros\" class=material-icons>search</md-icon> <span ng-hide=$ctrl.gridOptions.enableFiltering>Mostrar filtros</span> <span ng-show=$ctrl.gridOptions.enableFiltering>Ocultar filtros</span> </md-button> <div> <div ui-grid=$ctrl.gridOptions ui-grid-pagination class=myGrid></div> </div> </md-content> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/containers/admin-home/home.html
// module id = 152
// module chunks = 1